<template>
  <div class="color-picker">
    <div class="color-grid">
      <div
        v-for="colorOption in presetColors"
        :key="colorOption.color"
        class="color-option"
        :style="{ backgroundColor: colorOption.color }"
        @click="selectColor(colorOption.color)"
        :class="{ active: isColorActive(colorOption.color) }"
        :title="colorOption.name"
      ></div>
    </div>
    <div class="custom-color-section">
      <label class="custom-color-label">
        <span>Color personalizado</span>
        <input
          type="color"
          :value="value"
          @input="selectColor($event.target.value)"
          class="custom-color-input"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    value: {
      type: String,
      default: "#6366f1",
    },
  },
  data() {
    return {
      presetColors: [
        { color: "#55a3ff", name: "Light Greenish Blue" },
        { color: "#74b9ff", name: "Faded Poster" },
        { color: "#0984e3", name: "Green Darner Tail" },
        { color: "#a29bfe", name: "Shy Moment" },
        { color: "#00b894", name: "Mint Leaf" },
        { color: "#00cec9", name: "Robin's Egg Blue" },
        { color: "#2d3436", name: "Electron Blue" },
        { color: "#6c5ce7", name: "Exodus Fruit" },
        { color: "#fdcb6e", name: "Sour Lemon" },
        { color: "#fd79a8", name: "First Date" },
        { color: "#e84393", name: "Pink Glamour" },
        { color: "#f39c12", name: "Pico-8 Orange" },
        { color: "#e67e22", name: "Bright Yarrow" },
        { color: "#e17055", name: "Orangeville" },
        { color: "#d63031", name: "Chi-Gong" },
        { color: "#c44569", name: "Prunus Avium" },
      ],
    };
  },
  computed: {
    isColorActive() {
      return (color) => {
        if (!this.value || !color) return false;

        // Normalizar colores para comparación
        const normalizeColor = (c) => {
          return c.toLowerCase().trim();
        };

        const normalizedValue = normalizeColor(this.value);
        const normalizedColor = normalizeColor(color);

        return normalizedValue === normalizedColor;
      };
    },
  },

  methods: {
    selectColor(color) {
      this.$emit("input", color);
      this.$emit("change", color);
    },
  },
};
</script>

<style scoped>
.color-picker {
  background: var(--lego-bg);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--lego-border);
  min-width: 200px;
}

.dark .color-picker {
  background: var(--lego-oscuro);
  border-color: var(--lego-border-dark);
}

.color-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.color-option {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s ease;
  position: relative;
}

.color-option:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-option.active {
  border-color: var(--text-primary);
  box-shadow: 0 0 0 2px var(--lego-accent);
}

.color-option.active::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  font-weight: bold;
  font-size: 16px;
  text-shadow: 0 0 3px rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.custom-color-section {
  border-top: 1px solid var(--lego-border);
  padding-top: 12px;
}

.dark .custom-color-section {
  border-color: var(--lego-border-dark);
}

.custom-color-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary);
}

.custom-color-input {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background: transparent;
}

.custom-color-input::-webkit-color-swatch-wrapper {
  padding: 0;
  border-radius: 6px;
}

.custom-color-input::-webkit-color-swatch {
  border: none;
  border-radius: 6px;
}
</style>
